module.exports = __webpack_public_path__ + "static/media/parking.5cde5c1a.svg";